import {
  fetchMarketList,
  fetchNewStores,
  fetchAllItems,
  fetchNewArrival,
  getBillPaymentCategory,
  tenantConfigApi,
  tenantPreferenceApi,
  paymentConfigApi,
  tenaDetailsById,
  storeListApi,
  storeChatList,
} from "./services";
import { structureItemData } from "/src/helpers/items";

export default {
  namespaced: true,
  state: {
    chatList: [],
    marketList: null,
    newStores: [],
    defaultLocation: {
      City: "",
      Country: "",
      State: "",
      zip: "",
    },
    itemSuggestions: [],
    trendingItems: [],
    newArrivals: [],
    inStock: [],
    outOfStock: [],
    billCategoryList: [],
    marketListData: {},
    isLoading: false,
    tenantConfig: {},
    tenantPrefernce: {},
    paymentConfig: {},
    tenantDetails: {},
    currency: {},
    language: {},
    storeInfo: {},
  },

  actions: {
    fetchBillPaymentCategoryData: async ({ commit }) => {
      try {
        const payload = "62d4fef39c487b63efee8f03";
        const data = await getBillPaymentCategory(payload);
        commit("setBillCategoryData", data);
      } catch (e) {
        console.log(e);
      }
    },
    fetchTenantConfig: async ({ commit }) => {
      try {
        const data = await tenantConfigApi();
        commit("setTenantConfig", data.data.response);
      } catch (e) {
        console.log(e);
      }
    },
    fetchTenantPreference: async ({ commit }, id) => {
      try {
        const data = await tenantPreferenceApi(id);
        commit("setTenantPreference", data.data.response);
        commit("setCurrency", data.data.response.currency);
        commit("setLanguage", data.data.response);
      } catch (e) {
        console.log(e);
      }
    },
    fetchPaymentConfig: async ({ commit }, id) => {
      try {
        const data = await paymentConfigApi(id);
        commit("setPaymentConfig", data.data?.data?.payments || {});
        return data;
      } catch (e) {
        console.log(e);
      }
    },
    fetchTenantDetails: async ({ commit }, id) => {
      try {
        const data = await tenaDetailsById(id);
        commit("setTenantDetails", data.data?.response || {});
        return data;
      } catch (e) {
        console.log(e);
      }
    },
    fetchMarketList: async ({ commit }) => {
      try {
        // let City = [state.defaultLocation.City];
        // if (City === "") {
        // 	City = sessionStorage.getItem("eparisheva:location").data.City;
        // }
        const data = await fetchMarketList("");
        // const result = data.filter((x) => x.isMarket);
        commit("setMarketList", data);
      } catch (e) {
        //
      }
    },

    fetchNewStores: async ({ commit, state }, payload) => {
      try {
        if (
          !state.newStores ||
          Object.keys(state.newStores).length === 0 ||
          payload.refresh
        ) {
          delete payload.refresh;
          commit("setNewStores", []);
          const data = await fetchNewStores(payload);
          commit("setNewStores", data.response);
        }
      } catch (e) {
        //
      }
    },
    fetchAllItems: async (context) => {
      try {
        context.commit("setState", {
          itemSuggestions: [],
          newArrivals: [],
          trendingItems: [],
          isLoading: true,
        });
        let payloadData = {
          page: { page: 1, itemsPerPage: 20 },
        };
        // if (payload.city !== 6000 && payload.city != undefined) {
        // 	console.log("condition chcked");
        // 	payloadData.city = [payload.city];
        // }
        const result = await fetchAllItems(payloadData);

        context.commit("setState", {
          itemSuggestions: structureItemData(
            result.data?.itemSuggestions || [],
          ),
          newArrivals: structureItemData(result.data?.newArrivals || []),
          trendingItems: structureItemData(result.data?.trendingItems || []),
          isLoading: false,
        });
      } catch (e) {
        //
      }
    },
    async fetchChatList({ commit }) {
      try {
        const data = await storeChatList();
        commit("setChatList", data.data.chats);
        return data;
      } catch (error) {
        throw Error(
          error?.response?.data?.message ||
            `Api failed with error: ${error.message}`,
        );
      }
    },
    fetchMarketItemsData: async ({ commit, state }, location) => {
      try {
        const marketListData = {};
        const marketData = state.marketList.map(async (market) => {
          const dataPayload = {
            market: [market.name],
            page: { page: 1, itemsPerPage: 20 },
          };
          if (location === "") dataPayload["city"] = [""];

          const result = await fetchNewArrival(dataPayload);
          marketListData[market.name] = structureItemData(result.data);
          return;
        });
        await Promise.all(marketData);
        // commit("setMarketListData", marketListData);
        const result2 = await fetchNewArrival(this.dataPayload);
        commit("setnewArrivals", structureItemData(result2.data.newArrivals));
      } catch (e) {
        //
      }
    },

    setLocation: ({ commit, dispatch }, data) => {
      commit("setLocationData", data);
      dispatch("fetchAllItems", true);
      dispatch("fetchMarketItemsData");
      dispatch("fetchMarketList", true);
    },

    async fetchStoreDetails({ commit }, data) {
      try {
        let res = await storeListApi(data);
        commit("setStoreData", res.data?.response[0] || {});
        return res;
      } catch (error) {
        throw Error(
          error?.response?.data?.message ||
            `Api failed with error: ${error.message}`,
        );
      }
    },
  },
  mutations: {
    setBillCategoryData: (state, data) => {
      state.billCategoryList = data.filter((e) => e.isCategory == true);
    },
    setMarketList: (state, data) => {
      state.marketList = data;
    },
    setnewArrivals(state, data) {
      state.newArrivals = data;
      state.inStock = [];
      state.outOfStock = [];
      for (const item of data) {
        if (item.Availability === "IN STOCK") {
          state.inStock.push(item);
        } else {
          state.outOfStock.push(item);
        }
      }
    },
    setNewStores(state, data) {
      state.newStores = data;
      this.isLoading = false;
    },
    setChatList(state, payload) {
      state.chatList = payload;
    },
    setState: (state, data) => {
      Object.keys(data).map((field) => {
        state[field] = data && data[field] ? data[field] : [];
      });
      state.inStock = [];
      state.outOfStock = [];
      for (const item of state.newArrivals) {
        if (item.Availability === "IN STOCK") {
          state.inStock.push(item);
        } else {
          state.outOfStock.push(item);
        }
      }
    },

    setLocationData: (state, data) => {
      state.defaultLocation = data;
    },

    setMarketListData: (state, data) => {
      state.marketListData = data;
    },

    setStore: (state, data) => {
      state.stores = data;
    },
    setTenantConfig: (state, data) => {
      state.tenantConfig = data;
    },
    setTenantPreference: (state, data) => {
      state.tenantPrefernce = data;
    },
    setPaymentConfig: (state, data) => {
      state.paymentConfig = data;
    },
    setTenantDetails: (state, data) => {
      state.tenantDetails = data;
    },
    setCurrency(state, payload) {
      state.currency = payload;
    },
    setLanguage(state, payload) {
      state.language = payload;
    },
    setStoreData(state, payload) {
      state.storeInfo = payload;
    },
  },
};
